import { render, staticRenderFns } from "./TravelHistory.vue?vue&type=template&id=36229346&scoped=true"
import script from "./TravelHistory.vue?vue&type=script&lang=js"
export * from "./TravelHistory.vue?vue&type=script&lang=js"
import style0 from "./TravelHistory.vue?vue&type=style&index=0&id=36229346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36229346",
  null
  
)

export default component.exports